/* Luméonde — effets de lumière du thème.
   Aucun mécanisme de panier, de prix ou de variante n'est réécrit ici : la barre d'achat mobile
   se contente de refléter le bouton natif de Shopify et de le déclencher. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isReduced = function () {
    return reduced.matches;
  };

  /* --------------------------------------------------------------- utilitaires */

  function hexToRgb(hex) {
    var h = String(hex || '').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (isNaN(n) || h.length !== 6) return [47, 139, 255];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  function rgbToHue(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    if (d === 0) return -1; // gris ou blanc : pas de teinte
    var h;
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
    return h < 0 ? h + 360 : h;
  }

  function shiftHue(hex, deg) {
    var c = hexToRgb(hex);
    var r = c[0] / 255;
    var g = c[1] / 255;
    var b = c[2] / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var l = (max + min) / 2;
    var d = max - min;
    if (d === 0) return hex;
    var s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    var h = rgbToHue(c) + deg;
    h = ((h % 360) + 360) % 360 / 360;
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p2 = 2 * l - q;
    var hue = function (t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p2 + (q - p2) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p2 + (q - p2) * (2 / 3 - t) * 6;
      return p2;
    };
    var out = [hue(h + 1 / 3), hue(h), hue(h - 1 / 3)].map(function (v) {
      var n = Math.round(Math.min(1, Math.max(0, v)) * 255).toString(16);
      return n.length === 1 ? '0' + n : n;
    });
    return '#' + out.join('');
  }

  function luminance(rgb) {
    var f = rgb.map(function (v) {
      v = v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * f[0] + 0.7152 * f[1] + 0.0722 * f[2];
  }

  function darkenTo(rgb, target) {
    if (luminance(rgb) <= target) return rgb;
    var lo = 0;
    var hi = 1;
    for (var i = 0; i < 12; i++) {
      var t = (lo + hi) / 2;
      var mixed = rgb.map(function (v) {
        return v * (1 - t);
      });
      if (luminance(mixed) <= target) hi = t;
      else lo = t;
    }
    return rgb.map(function (v) {
      return Math.round(v * (1 - hi));
    });
  }

  function toCss(rgb) {
    return 'rgb(' + rgb[0] + ', ' + rgb[1] + ', ' + rgb[2] + ')';
  }

  function setAccent(el, hex, hex2) {
    var a = hexToRgb(hex);
    el.style.setProperty('--cb-accent', hex);
    el.style.setProperty('--cb-accent-rgb', a.join(', '));
    var darkest = luminance(a);
    if (hex2) {
      var b = hexToRgb(hex2);
      el.style.setProperty('--cb-accent-2', hex2);
      el.style.setProperty('--cb-accent-2-rgb', b.join(', '));
      darkest = Math.min(darkest, luminance(b));
    }
    // Un bouton doit rester lisible avec les seize teintes. Les couleurs claires gardent
    // leur éclat avec un libellé sombre ; les couleurs sombres sont assombries un peu plus
    // et prennent un libellé blanc.
    if (darkest >= 0.3) {
      el.style.setProperty('--cb-btn-ink', '#04060e');
      el.style.setProperty('--cb-btn-a', hex);
      el.style.setProperty('--cb-btn-b', hex2 || hex);
    } else {
      el.style.setProperty('--cb-btn-ink', '#ffffff');
      el.style.setProperty('--cb-btn-a', toCss(darkenTo(a, 0.11)));
      el.style.setProperty('--cb-btn-b', toCss(darkenTo(hexToRgb(hex2 || hex), 0.11)));
    }
  }

  /* ------------------------------------------------------ apparitions au scroll */

  function initReveal() {
    var targets = document.querySelectorAll('[data-cb-reveal]');
    if (!targets.length) return;
    document.documentElement.classList.add('cb-anim');
    if (!('IntersectionObserver' in window) || isReduced()) {
      targets.forEach(function (el) {
        el.classList.add('cb-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cb-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ------------------------------------------- vidéos : lecture à la visibilité */

  var managedVideos = [];

  function armVideo(video) {
    video.muted = true;
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
    if (video.dataset.cbTrimmed === 'true') return;
    video.dataset.cbTrimmed = 'true';

    // Extrait : certains plans ne gardent qu'un passage, celui où la teinte annoncée est à l'écran.
    var start = parseFloat(video.dataset.start);
    var end = parseFloat(video.dataset.end);
    if (isNaN(start) && isNaN(end)) return;
    var from = isNaN(start) ? 0 : start;

    var rewind = function () {
      try {
        video.currentTime = from;
      } catch (e) {
        /* la position n'est pas encore accessible : le prochain événement s'en chargera */
      }
    };

    video.addEventListener('loadedmetadata', rewind);
    video.addEventListener('timeupdate', function () {
      if (!isNaN(end) && video.currentTime >= end) rewind();
      else if (video.currentTime < from - 0.25) rewind();
    });
    if (video.readyState >= 1) rewind();
  }

  function initVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-cb-autoplay]'));
    if (!videos.length) return;

    if (isReduced()) {
      // Mouvement réduit : rien ne démarre seul, mais tout reste consultable à la demande.
      videos.forEach(function (video) {
        armVideo(video);
        video.setAttribute('controls', '');
        video.preload = 'none';
      });
      return;
    }

    managedVideos = videos;

    var play = function (video) {
      if (video.dataset.cbSuspended === 'true') return;
      armVideo(video);
      startVideo(video);
    };

    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          video.dataset.cbVisible = entry.isIntersecting ? 'true' : 'false';
          if (entry.isIntersecting && !document.hidden) play(video);
          else video.pause();
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (video) {
      io.observe(video);
    });

    document.addEventListener('visibilitychange', function () {
      managedVideos.forEach(function (video) {
        if (document.hidden) video.pause();
        else if (video.dataset.cbVisible === 'true') play(video);
      });
    });
  }

  // Un plan tronqué doit se placer sur sa première image avant de démarrer, sinon
  // le début du fichier apparaît une fraction de seconde.
  function startVideo(video) {
    var go = function () {
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    };
    var from = parseFloat(video.dataset.start);
    if (!isNaN(from) && video.readyState < 1) {
      video.addEventListener('loadedmetadata', go, { once: true });
      return;
    }
    go();
  }

  /* ---------------------------------------------------- héros : caustiques WebGL */

  var VERT = [
    'attribute vec2 a_pos;',
    'void main() { gl_Position = vec4(a_pos, 0.0, 1.0); }'
  ].join('\n');

  var FRAG = [
    'precision highp float;',
    'uniform vec2 u_res;',
    'uniform float u_time;',
    'uniform vec2 u_pointer;',
    'uniform vec3 u_colA;',
    'uniform vec3 u_colB;',
    'uniform float u_quality;',
    'void main() {',
    '  vec2 uv = gl_FragCoord.xy / u_res;',
    '  float aspect = u_res.x / max(u_res.y, 1.0);',
    '  vec2 q = vec2(uv.x * aspect, uv.y);',
    '  vec2 p = q * 6.2831 * 1.05 + (u_pointer - 0.5) * 0.35 - 250.0;',
    '  float t = u_time * 0.42 + 23.0;',
    '  vec2 i = p;',
    '  float c = 1.0;',
    '  float inten = 0.005;',
    '  float n2 = 0.0;',
    '  for (int n = 0; n < 5; n++) {',
    '    if (float(n) >= u_quality) break;',
    '    float tt = t * (1.0 - (3.5 / float(n + 1)));',
    '    i = p + vec2(cos(tt - i.x) + sin(tt + i.y), sin(tt - i.y) + cos(tt + i.x));',
    '    vec2 d = vec2(p.x / (sin(i.x + tt) / inten + 1e-4), p.y / (cos(i.y + tt) / inten + 1e-4));',
    '    c += 1.0 / max(length(d), 1e-3);',
    '    n2 += 1.0;',
    '  }',
    '  c /= max(n2, 1.0);',
    '  c = 1.17 - pow(max(c, 0.0), 1.4);',
    '  float caustic = clamp(pow(abs(c), 8.0), 0.0, 1.0);',
    '  float sweep = smoothstep(0.0, 1.0, uv.y * 0.8 + 0.25 * sin(u_time * 0.07 + uv.x * 2.0));',
    '  vec3 tint = mix(u_colB, u_colA, sweep);',
    '  vec3 base = vec3(0.012, 0.016, 0.04) + tint * 0.10;',
    '  float glow = exp(-2.2 * distance(uv, vec2(0.72, 0.38)));',
    '  float halo = exp(-3.0 * distance(uv, u_pointer));',
    '  vec3 col = base + tint * glow * 0.32 + tint * halo * 0.18;',
    '  col += tint * caustic * (0.75 + 0.9 * glow) + vec3(caustic * caustic) * 0.35;',
    '  float vig = 1.0 - 0.55 * pow(length((uv - 0.5) * vec2(1.1, 1.3)), 2.0);',
    '  col *= clamp(vig, 0.0, 1.0);',
    '  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);',
    '}'
  ].join('\n');

  function compile(gl, type, src) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, src);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  function initCaustics() {
    var canvas = document.querySelector('[data-cb-caustics]');
    if (!canvas) return null;

    var palette = [];
    try {
      palette = JSON.parse(canvas.dataset.palette || '[]');
    } catch (e) {
      palette = [];
    }
    if (palette.length < 2) palette = ['#2f8bff', '#17e0d0', '#8a3bff', '#ff3fa4'];

    var gl = null;
    try {
      gl = canvas.getContext('webgl', { antialias: false, alpha: false, depth: false, powerPreference: 'low-power' }) ||
        canvas.getContext('experimental-webgl', { antialias: false, alpha: false, depth: false });
    } catch (e) {
      gl = null;
    }
    if (!gl) return null;

    var vs = compile(gl, gl.VERTEX_SHADER, VERT);
    var fs = compile(gl, gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return null;

    var program = gl.createProgram();
    gl.attachShader(program, vs);
    gl.attachShader(program, fs);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
    gl.useProgram(program);

    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(program, 'a_pos');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var uRes = gl.getUniformLocation(program, 'u_res');
    var uTime = gl.getUniformLocation(program, 'u_time');
    var uPointer = gl.getUniformLocation(program, 'u_pointer');
    var uColA = gl.getUniformLocation(program, 'u_colA');
    var uColB = gl.getUniformLocation(program, 'u_colB');
    var uQuality = gl.getUniformLocation(program, 'u_quality');

    var narrow = window.matchMedia('(max-width: 749px)').matches;
    var quality = narrow ? 4 : 5;
    var maxDpr = narrow ? 1.25 : 1.6;

    var pointer = { x: 0.5, y: 0.55 };
    var target = { x: 0.5, y: 0.55 };
    var running = false;
    var visible = true;
    var frame = null;
    var start = performance.now();
    var last = 0;
    var minFrame = narrow ? 1000 / 34 : 1000 / 60;

    var rgbFloat = function (hex) {
      var c = hexToRgb(hex);
      return [c[0] / 255, c[1] / 255, c[2] / 255];
    };
    var stops = palette.map(rgbFloat);
    var hexStops = palette.slice();

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, maxDpr);
      var w = Math.max(1, Math.round(canvas.clientWidth * dpr));
      var h = Math.max(1, Math.round(canvas.clientHeight * dpr));
      if (canvas.width === w && canvas.height === h) return;
      canvas.width = w;
      canvas.height = h;
      gl.viewport(0, 0, w, h);
    }

    function mix3(a, b, k) {
      return [a[0] + (b[0] - a[0]) * k, a[1] + (b[1] - a[1]) * k, a[2] + (b[2] - a[2]) * k];
    }

    var onPalette = null;
    var lastIndex = -1;

    function draw(now) {
      frame = null;
      if (!running) return;
      if (now - last < minFrame) {
        frame = requestAnimationFrame(draw);
        return;
      }
      last = now;
      resize();
      var elapsed = (now - start) / 1000;

      // la teinte glisse lentement d'une couleur du cube à la suivante
      var cycle = 11;
      var pos = (elapsed / cycle) % stops.length;
      var index = Math.floor(pos);
      var k = pos - index;
      var eased = k * k * (3 - 2 * k);
      var a = stops[index];
      var b = stops[(index + 1) % stops.length];
      var colA = mix3(a, b, eased);
      var colB = mix3(stops[(index + 1) % stops.length], stops[(index + 2) % stops.length], eased);

      pointer.x += (target.x - pointer.x) * 0.055;
      pointer.y += (target.y - pointer.y) * 0.055;

      gl.uniform2f(uRes, canvas.width, canvas.height);
      gl.uniform1f(uTime, elapsed);
      gl.uniform2f(uPointer, pointer.x, pointer.y);
      gl.uniform3f(uColA, colA[0], colA[1], colA[2]);
      gl.uniform3f(uColB, colB[0], colB[1], colB[2]);
      gl.uniform1f(uQuality, quality);
      gl.drawArrays(gl.TRIANGLES, 0, 3);

      if (onPalette && index !== lastIndex) {
        lastIndex = index;
        onPalette(hexStops[index], hexStops[(index + 1) % hexStops.length]);
      }

      frame = requestAnimationFrame(draw);
    }

    function drawOnce() {
      resize();
      gl.uniform2f(uRes, canvas.width, canvas.height);
      gl.uniform1f(uTime, 7.5);
      gl.uniform2f(uPointer, 0.5, 0.55);
      gl.uniform3f(uColA, stops[0][0], stops[0][1], stops[0][2]);
      gl.uniform3f(uColB, stops[1][0], stops[1][1], stops[1][2]);
      gl.uniform1f(uQuality, quality);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    function stop() {
      running = false;
      if (frame) cancelAnimationFrame(frame);
      frame = null;
    }

    function play() {
      if (running || !visible || document.hidden || isReduced()) return;
      running = true;
      start = performance.now() - 7500;
      last = 0;
      frame = requestAnimationFrame(draw);
    }

    canvas.classList.add('cb-in');

    if (isReduced()) {
      drawOnce();
    } else {
      play();
    }

    window.addEventListener(
      'resize',
      function () {
        if (isReduced()) {
          drawOnce();
        }
      },
      { passive: true }
    );

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) play();
          else stop();
        },
        { threshold: 0 }
      ).observe(canvas);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else play();
    });

    canvas.addEventListener('webglcontextlost', function (event) {
      event.preventDefault();
      stop();
      canvas.classList.remove('cb-in');
    });

    var host = canvas.closest('[data-cb-hero]') || canvas.parentElement;
    if (host && window.matchMedia('(pointer: fine)').matches) {
      host.addEventListener(
        'pointermove',
        function (event) {
          var rect = host.getBoundingClientRect();
          target.x = (event.clientX - rect.left) / rect.width;
          target.y = 1 - (event.clientY - rect.top) / rect.height;
        },
        { passive: true }
      );
    }

    // Sur mobile, une inclinaison très légère remplace le pointeur quand le capteur est disponible.
    if (window.DeviceOrientationEvent && !window.matchMedia('(pointer: fine)').matches && !isReduced()) {
      window.addEventListener(
        'deviceorientation',
        function (event) {
          if (event.gamma == null || event.beta == null) return;
          target.x = Math.min(1, Math.max(0, 0.5 + event.gamma / 90));
          target.y = Math.min(1, Math.max(0, 0.5 + (event.beta - 45) / 90));
        },
        { passive: true }
      );
    }

    return {
      onPalette: function (fn) {
        onPalette = fn;
      }
    };
  }

  /* ------------------------------------------------ teinte courante de la page */

  var userPickedColor = false;

  function initHeroTint(caustics) {
    var hero = document.querySelector('[data-cb-hero]');
    if (!hero || !caustics) return;
    var root = document.documentElement;
    var heroVisible = true;

    caustics.onPalette(function (a, b) {
      if (userPickedColor || !heroVisible) return;
      setAccent(root, a, b);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          heroVisible = entries[0].isIntersecting;
        },
        { threshold: 0 }
      ).observe(hero);
    }
  }

  /* -------------------------------------------------------- section « teintes » */

  function initSpectrum() {
    var section = document.querySelector('[data-cb-spectrum]');
    if (!section) return;

    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-cb-swatch]'));
    if (!buttons.length) return;

    var clips = Array.prototype.slice.call(section.querySelectorAll('[data-cb-clip]'));
    var readout = section.querySelector('[data-cb-readout]');
    var root = document.documentElement;

    var filmed = buttons
      .filter(function (b) {
        return b.dataset.clip;
      })
      .map(function (b) {
        return { el: b, hue: rgbToHue(hexToRgb(b.dataset.color)), clip: b.dataset.clip, name: b.dataset.name };
      });

    function nearestFilmed(hex) {
      var hue = rgbToHue(hexToRgb(hex));
      var best = null;
      var bestD = Infinity;
      filmed.forEach(function (f) {
        if (f.hue < 0 || hue < 0) return;
        var d = Math.abs(f.hue - hue);
        if (d > 180) d = 360 - d;
        if (d < bestD) {
          bestD = d;
          best = f;
        }
      });
      return best || filmed[0] || null;
    }

    var stage = section.querySelector('.cb-spectrum__stage');
    var stageVisible = true;
    var activeClip = null;

    function showClip(id) {
      activeClip = id;
      clips.forEach(function (clip) {
        var on = clip.dataset.cbClip === id;
        clip.classList.toggle('cb-on', on);
        var video = clip.querySelector('video');
        if (!video) return;
        video.dataset.cbSuspended = on ? 'false' : 'true';
        // Rien ne se lance si la scène n'est pas à l'écran : un plan choisi puis quitté
        // ne doit pas continuer à tourner dans le vide.
        if (on && stageVisible && !isReduced()) {
          armVideo(video);
          startVideo(video);
        } else {
          video.pause();
        }
      });
    }

    if (stage && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          stageVisible = entries[0].isIntersecting;
          if (activeClip) showClip(activeClip);
        },
        { threshold: 0.1 }
      ).observe(stage);
    }

    function select(button, focus, silent) {
      var hex = button.dataset.color;
      var name = button.dataset.name || '';
      buttons.forEach(function (other) {
        var on = other === button;
        other.setAttribute('aria-pressed', on ? 'true' : 'false');
        other.tabIndex = on ? 0 : -1;
      });

      var companion = shiftHue(hex, 26);
      setAccent(section, hex, companion);
      if (!silent) {
        setAccent(root, hex, companion);
        // Les sections qui ont leur propre palette passent elles aussi à la teinte choisie.
        document.querySelectorAll('[data-cb-palette]').forEach(function (el) {
          setAccent(el, hex, companion);
        });
      }

      var own = button.dataset.clip;
      var match = own ? { clip: own, name: name } : nearestFilmed(hex);
      if (match) showClip(match.clip);

      if (readout) {
        if (own || !match) readout.textContent = name;
        else readout.textContent = name + ' · plan filmé en ' + (match.name || '').toLowerCase();
      }

      if (focus) button.focus();
    }

    buttons.forEach(function (button, index) {
      button.tabIndex = index === 0 ? 0 : -1;
      button.addEventListener('click', function () {
        userPickedColor = true;
        select(button, false);
      });
      button.addEventListener('keydown', function (event) {
        var delta = 0;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') delta = 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') delta = -1;
        else if (event.key === 'Home') delta = -index;
        else if (event.key === 'End') delta = buttons.length - 1 - index;
        else return;
        event.preventDefault();
        userPickedColor = true;
        var next = buttons[(index + delta + buttons.length) % buttons.length];
        select(next, true);
      });
    });

    // Au chargement, on montre la teinte filmée la plus proche de l'accent du thème,
    // sans imposer sa couleur au reste de la page tant que le visiteur n'a rien choisi.
    var themeAccent = getComputedStyle(root).getPropertyValue('--cb-accent').trim() || '#2f8bff';
    var opening = nearestFilmed(themeAccent);
    var initial =
      (opening &&
        buttons.filter(function (b) {
          return b.dataset.clip === opening.clip;
        })[0]) ||
      buttons.filter(function (b) {
        return b.dataset.clip;
      })[0] ||
      buttons[0];
    select(initial, false, true);
    userPickedColor = false;
  }

  /* ------------------------------------------------------------ rail de vidéos */

  function initRails() {
    document.querySelectorAll('[data-cb-rail-track]').forEach(function (scroller) {
      // Les deux boutons vivent dans l'en-tête de la section, pas dans la piste elle-même.
      var scope = scroller.closest('section') || document;
      scope.querySelectorAll('[data-cb-rail-go]').forEach(function (button) {
        button.addEventListener('click', function () {
          var dir = button.dataset.cbRailGo === 'prev' ? -1 : 1;
          var card = scroller.querySelector('.cb-reel');
          var step = card ? card.getBoundingClientRect().width + 20 : scroller.clientWidth * 0.8;
          scroller.scrollBy({ left: dir * step, behavior: isReduced() ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ------------------------------------------------------------ halo pointeur */

  function initSpots() {
    if (!window.matchMedia('(pointer: fine)').matches || isReduced()) return;
    document.querySelectorAll('[data-cb-spot]').forEach(function (el) {
      var queued = false;
      var x = 50;
      var y = 50;
      el.addEventListener(
        'pointermove',
        function (event) {
          var rect = el.getBoundingClientRect();
          x = ((event.clientX - rect.left) / rect.width) * 100;
          y = ((event.clientY - rect.top) / rect.height) * 100;
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            el.style.setProperty('--mx', x.toFixed(2) + '%');
            el.style.setProperty('--my', y.toFixed(2) + '%');
          });
        },
        { passive: true }
      );
    });
  }

  /* ---------------------------------------------------------------- en-tête */

  function initHeader() {
    var header = document.querySelector('[data-cb-header]');
    if (!header) return;
    var solid = false;
    var queued = false;
    var apply = function () {
      queued = false;
      var next = window.scrollY > 24;
      if (next === solid) return;
      solid = next;
      header.classList.toggle('cb-header--solid', solid);
    };
    window.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(apply);
      },
      { passive: true }
    );
    apply();
  }

  /* ------------------------------------------------------- parallaxe très léger */

  function initParallax() {
    if (isReduced()) return;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-cb-parallax]'));
    if (!targets.length || !window.matchMedia('(min-width: 950px)').matches) return;
    var queued = false;
    var apply = function () {
      queued = false;
      var y = window.scrollY;
      targets.forEach(function (el) {
        var amount = parseFloat(el.dataset.cbParallax) || 0.06;
        el.style.transform = 'translate3d(0, ' + (-y * amount).toFixed(2) + 'px, 0)';
      });
    };
    window.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(apply);
      },
      { passive: true }
    );
    apply();
  }

  /* --------------------------------------------------------- barre d'achat mobile */

  function initBuyBar() {
    var bar = document.querySelector('[data-cb-buybar]');
    if (!bar) return;

    var scope = document.querySelector('product-info') || document.querySelector('main');
    if (!scope) return;

    var nativeButton = scope.querySelector('button[type="submit"][id^="ProductSubmitButton-"]');
    if (!nativeButton) return;

    var barButton = bar.querySelector('[data-cb-buybar-button]');
    var barPrice = bar.querySelector('[data-cb-buybar-price]');

    function currentPriceText() {
      var total = scope.querySelector('cube-quantity-offer:not([hidden]) [data-cb-quantity-total]');
      if (total) return total.textContent.trim();
      var root = scope.querySelector('[id^="price-"]');
      if (!root) return null;
      var price = root.querySelector('.price');
      var onSale = price && price.classList.contains('price--on-sale');
      var item = onSale ? root.querySelector('.price-item--sale') : root.querySelector('.price-item--regular');
      if (!item) return null;
      var text = item.textContent.replace(/\s+/g, ' ').trim();
      return text.length ? text : null;
    }

    function sync() {
      var text = currentPriceText();
      if (text && barPrice) barPrice.textContent = text;

      var label = nativeButton.querySelector('span');
      barButton.textContent = (label ? label.textContent : nativeButton.textContent).trim();
      barButton.disabled = nativeButton.hasAttribute('disabled') || nativeButton.getAttribute('aria-disabled') === 'true';
    }

    barButton.addEventListener('click', function () {
      nativeButton.click();
    });

    sync();
    bar.hidden = false;

    var frame = null;
    var observer = new MutationObserver(function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        sync();
      });
    });
    observer.observe(scope, { subtree: true, childList: true, characterData: true, attributes: true });

    if ('IntersectionObserver' in window) {
      var anchor = nativeButton.closest('.product-form') || nativeButton;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('cb-buybar--tucked', entry.isIntersecting);
        });
      }).observe(anchor);
    }
  }

  /* ---------------------------------------------------------------- menu compact */

  function initMenu() {
    var menu = document.querySelector('[data-cb-menu]');
    if (!menu) return;

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        var summary = menu.querySelector('summary');
        if (summary) summary.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  }

  function init() {
    initHeader();
    initReveal();
    initVideos();
    initHeroTint(initCaustics());
    initSpectrum();
    initRails();
    initSpots();
    initParallax();
    initBuyBar();
    initMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
